import { render } from "./EscritorioSiguientesCitas.vue?vue&type=template&id=49cd301c"
import script from "./EscritorioSiguientesCitas.vue?vue&type=script&lang=js"
export * from "./EscritorioSiguientesCitas.vue?vue&type=script&lang=js"

import "./EscritorioSiguientesCitas.vue?vue&type=style&index=0&id=49cd301c&lang=css"

import exportComponent from "/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__